import { Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { NonworkableTaskTypeService } from '../../../../../services/nonworkable-tasktype.service';

@Component({
  selector: 'app-components-managecustomer-allocatework-nonworkabletasktypeflag',
  templateUrl: './NonworkableTaskTypeFlag.component.html'
})
export class NonworkableTaskTypeFlagComponent {
  @Input() customerId: number;
  @Input() taskTypeId: number;
  @Input() taskTypeName: string;
  @Input() flag: Boo.Objects.Work.SeoMinute.TaskTypeFlag;
  @Output() refresh = new EventEmitter();

  constructor(private nonworkableTaskTypeService: NonworkableTaskTypeService) { }

  allowReactivation = computed<boolean>(() => this.flag.Type !== Boo.Objects.Work.SeoMinute.Enums.FlagTypes.ExaustedForPeriod);

  reactivateNonworkableTaskType(): void {
    this.nonworkableTaskTypeService.reactivate(this.customerId, this.taskTypeId)
      .subscribe(() => {
        toastr.success(`${this.taskTypeName} has been reactivated`);
        this.refresh.emit();
      }, (err) => toastr.error(err));
  }
}
